import {SearchAutocomplete} from '../elements/SearchAutocomplete';
import {Product} from '@shopify/hydrogen/storefront-api-types';
import {Suspense} from 'react';

export function SearchInputContainer({
  placeholder,
  featuredProducts,
}: {
  placeholder?: string;
  featuredProducts?: Product[];
}) {
  return (
    <Suspense>
      <SearchAutocomplete placeholder={placeholder} />
    </Suspense>
  );
}
